import React, { useState } from 'react';
import { Button, Skeleton } from 'antd';
import { ArrowLeftIcon, ArrowRightIcon } from 'icons';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { ISubjectData } from 'modules/cabinet';
import { isEmptyArr, useSubjectsData } from 'modules/global';

import { Visible } from 'components';

import { nextStep, prevStep, setSubject } from '../store';

const SubjectSelectStep = () => {
  const t = useTranslations();
  const subjectsState = useAppSelector(state => state.authModal.data.subjectIds);
  const role = useAppSelector(state => state.authModal.data.role);

  const [selectedSubjects, setSelectedSubjects] = useState<number[]>(subjectsState || []);
  const dispatch = useAppDispatch();
  const { subjects, isLoading } = useSubjectsData({ isNotAll: true });

  const onContinue = () => {
    dispatch(setSubject(selectedSubjects));
    dispatch(nextStep());
  };

  const toggleSubject = (subject: ISubjectData) => {
    setSelectedSubjects(prev =>
      prev?.includes(subject.id) ? prev?.filter(id => id !== subject.id) : [...prev, subject.id]
    );
  };

  return (
    <div className="flex h-[94vh] sm:h-full w-full flex-col justify-between p-6">
      <div>
        <h3 className="mb-2 text-3xl font-semibold">
          {role === 'TEACHER' ? t('qaysi_fanlardan_dars_otasiz') : t('qaysi_fanlarga_qiziqasiz')}
        </h3>
        <p className="text-sm">
          {role === 'TEACHER' ? t('qaysi_fanlardan_dars_otasiz_desc') : t('qaysi_fanlarga_qiziqasiz_desc')}
        </p>
        <div className="mt-15 grid grid-cols-5 gap-3 sm:grid-cols-7 md:grid-cols-10">
          <Visible
            if={isLoading}
            else={
              <Visible
                if={isEmptyArr(subjects?.subject)}
                else={subjects?.subject.map(subject => (
                  <div key={subject.id}>
                    <div
                      onClick={() => toggleSubject(subject)}
                      className="flex cursor-pointer justify-center rounded-xl border py-3"
                      style={
                        selectedSubjects?.some(s => s === subject.id)
                          ? {
                              backgroundColor: `${subject.color}1F`,
                              border: `2px solid ${subject.color}`
                            }
                          : {
                              border: '2px solid #E7E7E7'
                            }
                      }
                    >
                      <Image
                        src={subject.image}
                        alt={subject.name.slice(0, 1)}
                        loading="lazy"
                        width={32}
                        height={32}
                        title="Subject list"
                      />
                    </div>
                    <p className="text-center text-xs text-gray-600">{subject.name.slice(0, 10)}</p>
                  </div>
                ))}
              >
                <div className="h-50  flex items-center justify-center text-gray-400">
                  <span className="w-40 text-center">{t('profile.left_side.fan_tanlanmagan')}</span>
                </div>
              </Visible>
            }
          >
            {Array.from({ length: 7 }).map((_, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Skeleton.Button key={index} className="!h-14 !w-16 !rounded-lg" active />
            ))}
          </Visible>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div className="text-gray-400">6/8</div>
        <div className="flex items-center gap-3">
          <Button
            onClick={() => dispatch(prevStep())}
            className="!py-5.5 !rounded-lg !border-none !border-transparent !bg-gray-100 !px-4 hover:!text-black"
          >
            <div className="mt-0.5 ">
              <ArrowLeftIcon size="18" />
            </div>
            {t('ortga')}
          </Button>
          <Button
            onClick={onContinue}
            disabled={isEmptyArr(selectedSubjects)}
            className="!rounded-lg !border-transparent !bg-green-500 !px-5 !py-5 !text-white disabled:!bg-gray-100 disabled:!text-gray-400"
          >
            {t('davom_etish')}
            <div className="mt-0.5 ">
              <ArrowRightIcon />
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubjectSelectStep;
